import { render, staticRenderFns } from "./app-btn.vue?vue&type=template&id=c0bdd962&scoped=true&"
import script from "./app-btn.vue?vue&type=script&lang=js&"
export * from "./app-btn.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c0bdd962",
  null
  ,true
)

export default component.exports